module.exports = __webpack_public_path__ + "img/icon_brand_scan_nfc.074ce8de.png";